<template>
  <div class="overview">
    <OverviewStats
      :center="center"
      :roomsCount="roomsCount"
      :fullCapacitySum="fullCapacitySum"
      :reducedCapacitySum="reducedCapacitySum"
      :occupiedRooms="occupiedRooms"
    ></OverviewStats>
  </div>
</template>

<script>
import OverviewStats from "@/components/components-salles/public/booking/overview/OverviewStats.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "ViewCenterStats",
  components: {
    OverviewStats,
  },
  computed: {
    ...mapGetters("centerModule", { centerById: "getCenterById" }),
    ...mapGetters("roomModule", { roomsByCenterId: "getRoomsByCenterId" }),

    center() {
      return this.centerById(parseInt(this.$route.params.id));
    },
    roomsCount() {
      return this.rooms().length;
    },
    fullCapacitySum() {
      return this.sumByProperty("fullCapacity");
    },
    reducedCapacitySum() {
      return this.sumByProperty("reducedCapacity");
    },
    occupiedRooms() {
      const res = this.rooms().filter((room) => room.available === false);
      return res.length;
    },
  },
  methods: {
    ...mapActions("centerModule", ["loadCentersWithDependents"]),
    ...mapActions("roomModule", ["loadRoomsWithDependents"]),
    ...mapActions("bookingModule", ["loadBookingsWithDependents"]),

    sumByProperty(propertyName) {
      const rooms = this.rooms();
      return rooms.reduce((total, room) => total + room[propertyName], 0);
    },
    rooms() {
      return this.roomsByCenterId(parseInt(this.$route.params.id));
    },
  },
  async mounted() {
    await this.loadCentersWithDependents();
    await this.loadRoomsWithDependents();
    await this.loadBookingsWithDependents();
  },
};
</script>

<style lang="scss" scoped>
.overview {
  margin: 0 1rem;
  display: flex;
  justify-content: center;
  width: 100%;
}
</style>
